import { computed, ref } from 'vue';
import { getJackpotFeature } from '@/api/jackpot';

/**
 * Jackpot kill-switch for C 端.
 * - Build-time force-off: VUE_APP_JACKPOT_ENABLED=false (default)
 * - Runtime SoT: GET /jackpot/feature from yaml jackpot.enabled
 * Both must allow before nav/routes surface (merge-safe / zero user impact when off).
 */
const envAllows =
  String(process.env.VUE_APP_JACKPOT_ENABLED ?? 'false').toLowerCase() === 'true';

const serverEnabled = ref(false);
const loaded = ref(false);
let inflight = null;

export async function refreshJackpotFeature() {
  if (!envAllows) {
    serverEnabled.value = false;
    loaded.value = true;
    return false;
  }
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const data = await getJackpotFeature();
      serverEnabled.value = !!data?.enabled;
    } catch {
      serverEnabled.value = false;
    } finally {
      loaded.value = true;
      inflight = null;
    }
    return serverEnabled.value;
  })();
  return inflight;
}

export function useJackpotFeature() {
  if (!loaded.value && envAllows) {
    refreshJackpotFeature();
  }
  const enabled = computed(() => envAllows && serverEnabled.value);
  return { enabled, loaded, refreshJackpotFeature };
}

export function isJackpotEnvAllowed() {
  return envAllows;
}
